import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isMenuOpened'
})
export class IsMenuOpenedPipe implements PipeTransform {
    transform(list: any, id: string, selected: string): boolean {
        return list ? list.some(child => child[id] == selected) : false;
    }
}
